/**
 * source: http://urlregex.com/
 * @type {RegExp}
 */
//eslint-disable-next-line
export const REGEX_URL = /(http(s)?:\/\/)(www.)?([\w\-]+\.)+(\w+)?([\w-\/\?\.=&#])*/gi;
export const LRM = String.fromCharCode(0x200e);
export const RLM = String.fromCharCode(0x200f);
export const REGEX_MENTION_TAG = /<a\shref=['"](profile|organization|clan|hashtag):\/\/([^'"]+?)['"]>(\u200e?[@#][^<]+?)<\/a>/gi;
